import Logo from "@/components/site/Logo";


const COLS = [
    {
        title: "Platform",
        links: [
            { label: "Smart Retail Suite", href: "#platform" },
            { label: "SmartCaddy", href: "https://smartcaddy.store/", external: true },
            { label: "Compare carts", href: "#compare" },
            { label: "Retail Media Network", href: "#platform" },
        ],
    },
    {
        title: "Company",
        links: [
            { label: "About", href: "#company" },
            { label: "Values", href: "#company" },
            { label: "Deployment", href: "#deploy" },
            { label: "Contact", href: "#contact" },
        ],
    },
    {
        title: "Resources",
        links: [
            { label: "Outcomes we optimise", href: "#deploy" },
            { label: "Security & privacy", href: "#contact" },
            { label: "Press / Media", href: "mailto:contact@retechler.com" },
            { label: "Privacy", href: "mailto:contact@retechler.com" },
        ],
    },
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-rt-bg border-t border-white/10 pt-20 pb-10 overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-12 mb-20">
                    <div className="lg:col-span-5">
                        <div className="mb-6">
                            <Logo height={42} />
                        </div>
                        <p className="text-rt-text2 text-sm max-w-md leading-relaxed">
                            The full-stack smart retail platform — hardware + AI + SaaS. ReTechler is an
                            independent retail-tech company; <a
                                href="https://smartcaddy.store/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-rt-teal hover:underline"
                            >SmartCaddy</a> is our first product line.
                        </p>
                        <div className="mt-6 text-xs font-mono uppercase tracking-[0.18em] text-rt-text3 space-y-1">
                            <div>contact@retechler.com</div>
                            <div>smartcaddy.store</div>
                        </div>
                    </div>

                    {COLS.map((c, i) => (
                        <div key={i} className="lg:col-span-2">
                            <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-rt-text3 mb-5">
                                {c.title}
                            </div>
                            <ul className="space-y-3">
                                {c.links.map((l, j) => (
                                    <li key={j}>
                                        <a
                                            href={l.href}
                                            target={l.external ? "_blank" : undefined}
                                            rel={l.external ? "noopener noreferrer" : undefined}
                                            data-testid={`footer-link-${c.title.toLowerCase()}-${j}`}
                                            className="text-sm text-white/75 hover:text-rt-teal transition-colors"
                                        >
                                            {l.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    <div className="lg:col-span-1" />
                </div>

                <div
                    aria-hidden
                    className="font-heading text-[20vw] leading-[0.85] tracking-tighter text-white/[0.04] select-none -mb-10 lg:-mb-16"
                >
                    ReTechler
                </div>

                <div className="border-t border-white/10 pt-6 flex flex-wrap items-center justify-between gap-3 text-xs font-mono uppercase tracking-[0.18em] text-rt-text3">
                    <div>© {new Date().getFullYear()} ReTechler · An independent retail-tech company</div>
                    <div className="flex items-center gap-2">
                        <span className="w-1.5 h-1.5 bg-rt-teal animate-pulse rounded-full" />
                        Caddy in test · more on roadmap
                    </div>
                </div>
            </div>
        </footer>
    );
}
